import ConfigService from "./ConfigService";
import HttpService from "./HttpService";




export default class getAuthResourceServiceHost
{
    constructor(authResourceDomain)
    {
        this.configService = new ConfigService();
        this.domain = authResourceDomain || this.configService.getAuthResourceServiceHost();
    }



    async fetchVersion(token)
    {
        const path = "/api/admin/version";
        var response = await HttpService.get(this.domain, path, token);
        return response;   
    }

    async pingCore(token) 
    {
        const path = "/api/admin/ping";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }
    
  


      async getScopesByRoles(roles, token)
      {
        var path = "/api/resources/gcauthscope/role/{firstrole}".replace("{firstrole}", roles[0]);
        var additionalRoles = roles.splice(1);
        if (additionalRoles.length > 0)
        {
            var queryString = additionalRoles.map((v, i) => "role=" + v).join("&");
            path = path + "?" + queryString;
        }
        // any additional roles are added as query string values
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }


      async getAppUsers(gcid, token)
      {
        "gcid/{gcid}/app/{app}/gcauthclient"
        var path = "/api/users/gcid/" + gcid + "/app/obs/gcauthclient";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }

      async getAppRoles(token)
      {
        var path = "/api/resources/gcauthrole/app/obs";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }

      async postAppUser(user, gcid, token)
      {
        var path = "/api/users/gcid/" + gcid + "/gcauthclient";
        var postObj = JSON.stringify(user);
        var response = await HttpService.postJson(this.domain, path, token, postObj);
        return response;
      }

      async deleteAppUser(userToDeleteId, gcid, token)
      {
        var path = "/api/users/gcid/" + gcid + "/gcauthclientdeleterequest/id/" + userToDeleteId;
        var response = await HttpService.postJson(this.domain, path, token, JSON.stringify(userToDeleteId));
        return response;
      }

      async postAppUserEnabledFlag(userToEnableId, newFlagStatusBool, gcid, token)
      {
        var path = "/api/users/gcid/" + gcid + "/gcauthclientenabledflagrequest/id/" + userToEnableId + "/enabled/" + newFlagStatusBool.toString();
        var postObj = JSON.stringify(newFlagStatusBool);
        var response = await HttpService.postJson(this.domain, path, token, postObj);
        return response;
      }

}